import $ from 'jquery';
import Swiper from 'swiper/bundle';

$('.mdd-widget').each(function () {
    const current = $(this);

    new Swiper(current[0], {
        slidesPerView: 2,
        spaceBetween: 30,
        watchOverflow: true,
    });
});
